export const convertArrayToString = (arr: string[]): string => {
	return arr.join(', ')
}
